import { render, staticRenderFns } from "./IconPeopleCap.vue?vue&type=template&id=0f389b9c"
import script from "./IconPeopleCap.vue?vue&type=script&lang=js"
export * from "./IconPeopleCap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports